import {Component, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {ReplaySubject} from 'rxjs';
import {Model} from '../../../../../domain/model/common/model.class';
import {ActivatedRoute} from '@angular/router';
import {FormErrors} from '../../../../../components/forms/validation/form-validator.class';
import {StepScreenModel} from '../../../../shared/step/step-screen.component';
import {FileLocation, FileLocationFactory} from '../../../../../components/files/service/file-location.class';
import {DeaRegistrationService} from '../../../../../domain/model/licenses-certifications/dea/dea-registration.service';
import {DeaRegistrationScreensManager} from './dea-registration-screens-manager.service';
import {DeaRegistration} from '../../../../../domain/model/licenses-certifications/dea/dea-registration.model';
import moment = require('moment');
import ProjectionInformation = Model.ProjectionInformation;
import { VerificationService } from '../../../../../components/verification/service/verification.service';

@Component({
    template: require('./dea-registration-screen.component.html')
})
export class DeaRegistrationScreenComponent {

    constructor(readonly modelService: DeaRegistrationService,
                readonly route: ActivatedRoute,
                readonly screensManager: DeaRegistrationScreensManager,
                readonly fileLocationFactory: FileLocationFactory,
                readonly verificationService: VerificationService) {}

    // region Form
    readonly form$ = new ReplaySubject<NgForm>(1);

    @ViewChild(NgForm) set form(value: NgForm) {
        this.form$.next(value);
    }

    // endregion

    registrationNumberMask = [/[a-zA-Z]/, /[a-zA-Z]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
    dateIssuedConstrains = {
        min: moment().subtract(100, 'year'),
        max: moment().add(5, 'year')
    };
    expirationDateConstrains = {
        min: moment().subtract(5, 'year'),
        max: moment().add(20, 'year'),
    };
    supportingDocumentFileLocation: FileLocation;

    get index(): number {
        return +this.route.snapshot.params['index'];
    }

    stepScreenModel = new StepScreenModel<DeaRegistration>({
        initialDataModel: new DeaRegistration(),
        specificValidationMessages: {
            registrationNumber: 'This field should be 2 letters followed by 7 numbers.'
        },
        screensManager: this.screensManager,
        _loadDataFn: () => {
            this.supportingDocumentFileLocation = this.fileLocationFactory.create('deaRegistration', `currentUser/${this.index}`, new ProjectionInformation('supportingDocument'));
            this.verificationService.setUrl('deaRegistration', undefined, `${this.index}`);
            return this.modelService.getCurrentUserModelEntry(this.index);
        },
        _submitDataFn: (model: DeaRegistration) => {
            return this.modelService.updateCurrentUserModelEntry(this.index, model);
        },
        _hasYesNoQuestion: () => this.modelService.doesCurrentUserModelEntryExist(this.index).map(r => !r)
    });

    get model(): DeaRegistration {
        return this.stepScreenModel.dataModel;
    }

    get formErrors(): FormErrors {
        return this.stepScreenModel.formErrors;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/licenses-certifications/steps/dea/dea-registration/dea-registration-screen.component.ts